module.exports = __webpack_public_path__ + "img/employee-kareem-reda.7fe64046.jpg";